import { render } from "./Slip.vue?vue&type=template&id=49f1f7d2"
import script from "./Slip.vue?vue&type=script&lang=js"
export * from "./Slip.vue?vue&type=script&lang=js"

import exportComponent from "/Applications/MAMP/htdocs/ADP_CashParis/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__